<template>
  <div class="page-content">
    <div class="left-right-div d-layout-row d-mult-col d-clearfix">
      <div class="left-div J_LayoutArea d-layout d-w190" data-size="190" data-region="left">
        <div class="fn-clear  colorGoodsSort-922474" modeid="29" instanceid="416162477" module-name="GoodsSort" style=";margin-bottom: px" origin="0" moduletemplateid="922474" data-has-point="true">
          <div class="mc" style=";">
            <div class="j-module" module-function="extendMenu" module-param="{needSelected:true}">
              <div class="jOneLevel">
                <span class="jClassi">CLASSIFICATION</span>
                <div class="jHead"><span class="jDottedleft"></span>商品分类<span class="jDottedRight"></span></div>
              </div>
              <div class="jOneLevelarea">
                <div class="jTwoLevel" data-num="0"><span class="jIconArrow"></span><a title="冰箱贴" href="javascript:void(0);" clstag="pageclick|keycount|GoodsSort_416162477_1|13469802">冰箱贴</a></div>
              </div>
              <div class="jOneLevelarea">
                <div class="jTwoLevel" data-num="0"><span class="jIconArrow"></span><a title="徽章钥匙扣" href="javascript:void(0);" clstag="pageclick|keycount|GoodsSort_416162477_2|13469802">徽章钥匙扣</a></div>
              </div>
              <div class="jOneLevelarea">
                <div class="jTwoLevel" data-num="0"><span class="jIconArrow"></span><a title="工艺品" href="javascript:void(0);" clstag="pageclick|keycount|GoodsSort_416162477_3|13469802">工艺品</a></div>
              </div>
              <div class="jOneLevelarea">
                <div class="jTwoLevel" data-num="0"><span class="jIconArrow"></span><a title="服装" href="javascript:void(0);" clstag="pageclick|keycount|GoodsSort_416162477_20|13469802">服装</a></div>
              </div>
              <div class="jOneLevelarea">
                <div class="jTwoLevel" data-num="0"><span class="jIconArrow"></span><a title="毛绒玩具" href="javascript:void(0);" clstag="pageclick|keycount|GoodsSort_416162477_21|13469802">毛绒玩具</a></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="J_LayoutArea d-layout d-w790" data-size="790" data-region="right-extra">
        <div class="fn-clear  JColorSearchList-905542" modeid="55555" instanceid="416162478" module-name="AllGoods" style="margin-bottom:0px;;margin-bottom: 0px" origin="0" moduletemplateid="905542" data-has-point="true">
          <div class="mc" style=";">



            <div class="j-module" module-function="changePhoto,movePhoto,saleAttent,renderComment" module-param="{attentType:'product', isDialog:false,node:'.jSubObject', subObj:'.jSubObject', changePhotoNode:'.jPic img' , smallPhoto:'.jScrollWrap li', title:'.jDesc a', eventType:'mouseenter', movePhotoNode:'.jScrollWrap li' , arrowPrev:'.jScrollPrev', arrowNext:'.jScrollNext', defaultClass:'jCurrent'}">
              <div class="JColorSearchList">
                <div id="J_filter" class="filter">
                  <div class="f-line">
                    <div class="g-sort">
                      <a class=" jCurrent   down " orderby="1" href="javascript:void(0);" onclick="searchGoodsList(this)"><em></em>上架时间</a>
                      <a class="  down " orderby="3" href="javascript:void(0);" onclick="searchGoodsList(this)"><em></em>好评度</a>
                      <a class="  down " orderby="4" href="javascript:void(0);" onclick="searchGoodsList(this)"><em></em>价格</a>
                      <a class="  down " orderby="5" href="javascript:void(0);" onclick="searchGoodsList(this)"><em></em>销量</a>
                    </div>
                    <div id="J_topPage" class="g-pager">
                      <span class="fp-text"><b>1</b><em>/</em><i>2</i></span>
                      <a class="fp-prev disabled " href="javascript:;" onclick="return false;">&lt;</a>
                      <a class="fp-next" onclick="pageGoodsList(1 + 1, this)" href="javascript:;">&gt;</a>
                    </div>
                    <div class="f-result-sum">共<span id="J_resCount">39</span>件商品</div>
                    <span class="clr"></span>
                  </div>
                </div>
                <div id="J_GoodsList" class="goods-list gl-type-1 J-goods-list">
                  <ul class="gl-warp clearfix">
                    <li class="jSubObject gl-item" clstag="pageclick|keycount|AllGoods_416162478_1|13469802">
                      <div class="gl-i-wrap">
                        <div class="jPic">
                          <a target="_blank" href="javascript:void(0);" jshop="url" data-sku="10177588933651">
                            <img width="188" height="188" class="err-product" src="./beijing/880cc6b0-993b-4de0-a0a6-200e545e85ff.png">
                          </a>
                        </div>
                        <div class="jScroll">
                          <a class="jScrollBtn jScrollPrev" href="javascript:;"></a>
                          <div class="jScrollWrap">
                            <ul>
                              <li data-href="//item.jd.com/10177588933651.html" data-src="./beijing/880cc6b0-993b-4de0-a0a6-200e545e85ff.png" sid="10177588933651" class="jCurrent">
                                <a title="" class="" href="javascript:;">
                                  <img width="25" height="25" alt="" src="./beijing/880cc6b0-993b-4de0-a0a6-200e545e85ff.png" class="err-product">
                                </a>
                              </li>
                            </ul>
                          </div>
                          <a class="jScrollBtn jScrollNext" href="javascript:;">&gt;</a>
                        </div>
                        <div class="jGoodsInfo">
                          <div class="jPrice">
                            <div class="jdPrice" free-handle="0">
                              <span class="jRmb">￥</span>
                              <span class="jdNum" jdprice="10177588933651" data-sku-encrypt="3c5f473648635a74f7cdaa8a2bd849422b80ed0c4b81ad7c79815f44ed07486a" preprice="79.00">79.00</span>
                            </div>
                          </div>
                          <div class="jDesc">
                            <a href="javascript:void(0);" target="_blank" title="又梨入画如梦·卷系列手办盲盒">又梨入画如梦·卷系列手办盲盒</a>
                          </div>
                          <div class="jExtra">
                            <a href="https://item.jd.com/10177588933651.html#comment" target="_blank" style="display: block;">已有<em class="jCommentNum" jdcomment="10177588933651">0</em>人评价</a>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li class="jSubObject gl-item" clstag="pageclick|keycount|AllGoods_416162478_3|13469802">
                      <div class="gl-i-wrap">
                        <div class="jPic">
                          <a target="_blank" href="javascript:void(0);" jshop="url" data-sku="10182100759531">
                            <img width="188" height="188" class="err-product" src="./beijing/317fede5-563d-4f74-8017-90367c99e3c2.png">
                          </a>
                        </div>
                        <div class="jScroll">
                          <a class="jScrollBtn jScrollPrev" href="javascript:;"></a>
                          <div class="jScrollWrap">
                            <ul>
                              <li data-href="//item.jd.com/10182100759531.html" data-src="./beijing/317fede5-563d-4f74-8017-90367c99e3c2.png" sid="10182100759531" class="jCurrent">
                                <a title="" class="" href="javascript:;">
                                  <img width="25" height="25" alt="" src="./beijing/317fede5-563d-4f74-8017-90367c99e3c2.png" class="err-product">
                                </a>
                              </li>
                            </ul>
                          </div>
                          <a class="jScrollBtn jScrollNext" href="javascript:;">&gt;</a>
                        </div>
                        <div class="jGoodsInfo">
                          <div class="jPrice">
                            <div class="jdPrice" free-handle="0">
                              <span class="jRmb">￥</span>
                              <span class="jdNum" jdprice="10182100759531" data-sku-encrypt="3c5f473648635a74f7cdaa8a2bd849427e572235c4bc9616ba9984465a6464b7" preprice="128.00">128.00</span>
                            </div>
                          </div>
                          <div class="jDesc">
                            <a href="javascript:void(0);" target="_blank" title="六龙三凤冠金属冰箱贴">六龙三凤冠金属冰箱贴</a>
                          </div>
                          <div class="jExtra">
                            <a href="https://item.jd.com/10182100759531.html#comment" target="_blank" style="display: block;">已有<em class="jCommentNum" jdcomment="10182100759531">0</em>人评价</a>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li class="jSubObject gl-item" clstag="pageclick|keycount|AllGoods_416162478_5|13469802">
                      <div class="gl-i-wrap">
                        <div class="jPic">
                          <a target="_blank" href="javascript:void(0);" jshop="url" data-sku="10180273669050">
                            <img width="188" height="188" class="err-product" src="./beijing/1aab0f06-fd72-4cc4-ae08-38b94bbd7878.png">
                          </a>
                        </div>
                        <div class="jScroll">
                          <a class="jScrollBtn jScrollPrev" href="javascript:;"></a>
                          <div class="jScrollWrap">
                            <ul>
                              <li data-href="//item.jd.com/10180273669050.html"
                                  data-src="./beijing/1aab0f06-fd72-4cc4-ae08-38b94bbd7878.png" sid="10180273669050" class="jCurrent">
                                <a title="" class="" href="javascript:;">
                                  <img width="25" height="25" alt="" src="./beijing/1aab0f06-fd72-4cc4-ae08-38b94bbd7878.png" class="err-product">
                                </a>
                              </li>
                            </ul>
                          </div>
                          <a class="jScrollBtn jScrollNext" href="javascript:;">&gt;</a>
                        </div>
                        <div class="jGoodsInfo">
                          <div class="jPrice">
                            <div class="jdPrice" free-handle="0">
                              <span class="jRmb">￥</span>
                              <span class="jdNum" jdprice="10180273669050" data-sku-encrypt="3c5f473648635a74f7cdaa8a2bd84942ce4475d1c848b59f9a5e6c497cdd3ec9" preprice="79.00">79.00</span>
                            </div>
                          </div>
                          <div class="jDesc">
                            <a href="javascript:void(0);" target="_blank" title="百子衣冰箱贴">百子衣冰箱贴</a>
                          </div>
                          <div class="jExtra">
                            <a href="javascript:void(0);" target="_blank" style="display: block;">已有<em class="jCommentNum" jdcomment="10180273669050">1</em>人评价</a>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li class="jSubObject gl-item" clstag="pageclick|keycount|AllGoods_416162478_7|13469802">
                      <div class="gl-i-wrap">
                        <div class="jPic">
                          <a target="_blank" href="javascript:void(0);" jshop="url" data-sku="10180273140615">
                            <img width="188" height="188" class="err-product" src="./beijing/3fed7836-e7fe-405e-b4c8-665b702dee26.png">
                          </a>
                        </div>
                        <div class="jScroll">
                          <a class="jScrollBtn jScrollPrev" href="javascript:;"></a>
                          <div class="jScrollWrap">
                            <ul>
                              <li data-href="//item.jd.com/10180273140615.html" data-src="./beijing/3fed7836-e7fe-405e-b4c8-665b702dee26.png" sid="10180273140615" class="jCurrent">
                                <a title="" class="" href="javascript:;">
                                  <img width="25" height="25" alt="" src="./beijing/3fed7836-e7fe-405e-b4c8-665b702dee26.png" class="err-product">
                                </a>
                              </li>
                            </ul>
                          </div>
                          <a class="jScrollBtn jScrollNext" href="javascript:;">&gt;</a>
                        </div>
                        <div class="jGoodsInfo">
                          <div class="jPrice">
                            <div class="jdPrice" free-handle="0">
                              <span class="jRmb">￥</span>
                              <span class="jdNum" jdprice="10180273140615" data-sku-encrypt="3c5f473648635a74f7cdaa8a2bd849424a30ee9bf97e869d9df374050e6b108f" preprice="79.00">79.00</span>
                            </div>
                          </div>
                          <div class="jDesc">
                            <a href="javascript:void(0);" target="_blank" title="皮弁冠冰箱贴">皮弁冠冰箱贴</a>
                          </div>
                          <div class="jExtra">
                            <a href="https://item.jd.com/10180273140615.html#comment" target="_blank" style="display: block;">已有<em class="jCommentNum" jdcomment="10180273140615">0</em>人评价</a>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li class="jSubObject gl-item" clstag="pageclick|keycount|AllGoods_416162478_9|13469802">
                      <div class="gl-i-wrap">
                        <div class="jPic">
                          <a target="_blank" href="//item.jd.com/10180269086149.html" jshop="url" data-sku="10180269086149">
                            <img width="188" height="188" class="err-product" src="./beijing/9b58fb70-7476-47b8-91bd-e6295d586b68.png">
                          </a>
                        </div>
                        <div class="jScroll">
                          <a class="jScrollBtn jScrollPrev" href="javascript:;"></a>
                          <div class="jScrollWrap">
                            <ul>
                              <li data-href="//item.jd.com/10180269086149.html"
                                  data-src="./beijing/9b58fb70-7476-47b8-91bd-e6295d586b68.png" sid="10180269086149" class="jCurrent">
                                <a title="" class="" href="javascript:;">
                                  <img width="25" height="25" alt="" src="./beijing/9b58fb70-7476-47b8-91bd-e6295d586b68.png" class="err-product">
                                </a>
                              </li>
                            </ul>
                          </div>
                          <a class="jScrollBtn jScrollNext" href="javascript:;">&gt;</a>
                        </div>
                        <div class="jGoodsInfo">
                          <div class="jPrice">
                            <div class="jdPrice" free-handle="0">
                              <span class="jRmb">￥</span>
                              <span class="jdNum" jdprice="10180269086149" data-sku-encrypt="3c5f473648635a74f7cdaa8a2bd8494255b3f9da17d2ee41be3f6b14dd73339c" preprice="79.00">79.00</span>
                            </div>
                          </div>
                          <div class="jDesc">
                            <a href="//item.jd.com/10180269086149.html" target="_blank" title="乌纱翼善冠冰箱贴">乌纱翼善冠冰箱贴</a>
                          </div>
                          <div class="jExtra">
                            <a href="https://item.jd.com/10180269086149.html#comment" target="_blank" style="display: block;">已有<em class="jCommentNum" jdcomment="10180269086149">1</em>人评价</a>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li class="jSubObject gl-item" clstag="pageclick|keycount|AllGoods_416162478_11|13469802">
                      <div class="gl-i-wrap">
                        <div class="jPic">
                          <a target="_blank" href="//item.jd.com/10180263353313.html" jshop="url" data-sku="10180263353313">
                            <img width="188" height="188" class="err-product" src="./beijing/a45a6485-7bf8-40b6-b915-a88c37ddb81e.png">
                          </a>
                        </div>
                        <div class="jScroll">
                          <a class="jScrollBtn jScrollPrev" href="javascript:;"></a>
                          <div class="jScrollWrap">
                            <ul>
                              <li data-href="//item.jd.com/10180263353313.html"
                                  data-src="./beijing/a45a6485-7bf8-40b6-b915-a88c37ddb81e.png" sid="10180263353313" class="jCurrent">
                                <a title="" class="" href="javascript:;">
                                  <img width="25" height="25" alt="" src="./beijing/a45a6485-7bf8-40b6-b915-a88c37ddb81e.png" class="err-product">
                                </a>
                              </li>
                            </ul>
                          </div>
                          <a class="jScrollBtn jScrollNext" href="javascript:;">&gt;</a>
                        </div>
                        <div class="jGoodsInfo">
                          <div class="jPrice">
                            <div class="jdPrice" free-handle="0">
                              <span class="jRmb">￥</span>
                              <span class="jdNum" jdprice="10180263353313" data-sku-encrypt="3c5f473648635a74f7cdaa8a2bd84942aa08d5b11fc1132eeffc85d240505e4f" preprice="118.00">118.00</span>
                            </div>
                          </div>
                          <div class="jDesc">
                            <a href="//item.jd.com/10180263353313.html" target="_blank" title="仅你好运金榜题名冰箱贴">仅你好运金榜题名冰箱贴</a>
                          </div>
                          <div class="jExtra">
                            <a href="https://item.jd.com/10180263353313.html#comment" target="_blank" style="display: block;">已有<em class="jCommentNum" jdcomment="10180263353313">0</em>人评价</a>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li class="jSubObject gl-item" clstag="pageclick|keycount|AllGoods_416162478_13|13469802">
                      <div class="gl-i-wrap">
                        <div class="jPic">
                          <a target="_blank" href="//item.jd.com/10180259685109.html" jshop="url" data-sku="10180259685109">
                            <img width="188" height="188" class="err-product" src="./beijing/47e502f6-594d-42cb-b0ee-849fc0d7d0b4.png">
                          </a>
                        </div>
                        <div class="jScroll">
                          <a class="jScrollBtn jScrollPrev" href="javascript:;"></a>
                          <div class="jScrollWrap">
                            <ul>
                              <li data-href="//item.jd.com/10180259685109.html" data-src="./beijing/47e502f6-594d-42cb-b0ee-849fc0d7d0b4.png" sid="10180259685109" class="jCurrent">
                                <a title="" class="" href="javascript:;">
                                  <img width="25" height="25" alt="" src="./beijing/47e502f6-594d-42cb-b0ee-849fc0d7d0b4.png" class="err-product">
                                </a>
                              </li>
                            </ul>
                          </div>
                          <a class="jScrollBtn jScrollNext" href="javascript:;">&gt;</a>
                        </div>
                        <div class="jGoodsInfo">
                          <div class="jPrice">
                            <div class="jdPrice" free-handle="0">
                              <span class="jRmb">￥</span>
                              <span class="jdNum" jdprice="10180259685109" data-sku-encrypt="3c5f473648635a74f7cdaa8a2bd8494272b5d6f1bc9871a02dd71a82e5b98bf9" preprice="128.00">128.00</span>
                            </div>
                          </div>
                          <div class="jDesc">
                            <a href="//item.jd.com/10180259685109.html" target="_blank" title="十二龙九凤金属冰箱贴">十二龙九凤金属冰箱贴</a>
                          </div>
                          <div class="jExtra">
                            <a href="https://item.jd.com/10180259685109.html#comment" target="_blank" style="display: block;">已有<em class="jCommentNum" jdcomment="10180259685109">0</em>人评价</a>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li class="jSubObject gl-item" clstag="pageclick|keycount|AllGoods_416162478_15|13469802">
                      <div class="gl-i-wrap">
                        <div class="jPic">
                          <a target="_blank" href="//item.jd.com/10180258211954.html" jshop="url" data-sku="10180258211954">
                            <img width="188" height="188" class="err-product" src="./beijing/b0c864c7-ae55-49c9-aa10-d471960ddc08.png">
                          </a>
                        </div>
                        <div class="jScroll">
                          <a class="jScrollBtn jScrollPrev" href="javascript:;"></a>
                          <div class="jScrollWrap">
                            <ul>
                              <li data-href="//item.jd.com/10180258211954.html"
                                  data-src="./beijing/b0c864c7-ae55-49c9-aa10-d471960ddc08.png" sid="10180258211954" class="jCurrent">
                                <a title="" class="" href="javascript:;">
                                  <img width="25" height="25" alt="" src="./beijing/b0c864c7-ae55-49c9-aa10-d471960ddc08.png" class="err-product">
                                </a>
                              </li>
                            </ul>
                          </div>
                          <a class="jScrollBtn jScrollNext" href="javascript:;">&gt;</a>
                        </div>
                        <div class="jGoodsInfo">
                          <div class="jPrice">
                            <div class="jdPrice" free-handle="0">
                              <span class="jRmb">￥</span>
                              <span class="jdNum" jdprice="10180258211954" data-sku-encrypt="3c5f473648635a74f7cdaa8a2bd8494289eb112811c7208f544823262b373c69" preprice="49.00">49.00</span>
                            </div>
                          </div>
                          <div class="jDesc">
                            <a href="//item.jd.com/10180258211954.html" target="_blank" title="大明风华灯笼金属冰箱贴">大明风华灯笼金属冰箱贴</a>
                          </div>
                          <div class="jExtra">
                            <a href="https://item.jd.com/10180258211954.html#comment" target="_blank" style="display: block;">已有<em class="jCommentNum" jdcomment="10180258211954">0</em>人评价</a>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                  <span class="clr"></span>
                  <div class="jPage">
                    <span class="jPageDisable">&lt; 上一页</span>

                    <a class="jPageCurrent">1</a>
                    <a href="javascript:;" onclick="pageGoodsList(2, this)">2</a>
                    <a href="javascript:;" onclick="pageGoodsList(1 + 1, this)">下一页 &gt;</a>
                  </div>
                </div>
              </div>
            </div>



          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "BeijingGiftHome"
}
</script>

<style scoped>
.JColorSearchList-905542 {
  position: relative;
  padding-bottom: 30px;
  overflow: hidden;
}
.JColorSearchList-905542 .clearfix {
  overflow: auto;
  zoom: 1;
}
.JColorSearchList-905542 .filter .f-line {
  padding: 6px 10px;
  background: #F8F8F8;
  zoom: 1;
}
.JColorSearchList-905542 .filter {
  position: relative;
  z-index: 4;
  margin-bottom: 20px;
}
.JColorSearchList-905542 .filter .g-pager .fp-text b, .JColorSearchList-905542 .filter .g-pager .fp-text em, .JColorSearchList-905542 .filter .g-pager .fp-text i {
  font-weight: 400;
  font-style: normal;
}
.JColorSearchList-905542 .filter .g-sort {
  float: left;
}
.JColorSearchList-905542 .filter .g-sort a {
  float: left;
  position: relative;
  padding: 0 10px;
  height: 22px;
  border: 1px solid #e1e1e1;
  margin-right: -1px;
  line-height: 22px;
  background: #FFF;
  color: #333;
}
.JColorSearchList-905542 .filter .g-sort a:hover {
  color: #e4393c;
  border: solid 1px #e4393c;
}
.JColorSearchList-905542 .filter .g-sort a:hover:after {
  content: '';
  width: 1px;
  height: 24px;
  background-color: #e4393c;
  position: absolute;
  right: -1px;
  z-index: 1;
  top: -1px;
}
.JColorSearchList-905542 .filter .g-sort a.jCurrent {
  background-color: #e4393c;
  color: #fff;
}
.JColorSearchList-905542 .filter .g-sort a.jCurrent.up em {
  background: url(//img14.360buyimg.com/cms/jfs/t169/241/1890751726/1114/417d81a4/53be3644N3aaf1af2.gif);
  display: inline-block;
  zoom: 1;
  height: 11px;
  margin-right: 5px;
  width: 9px;
  overflow: hidden;
  vertical-align: middle;
}
.JColorSearchList-905542 .filter .g-sort a.jCurrent.down em {
  background: url(//img13.360buyimg.com/cms/jfs/t187/96/1871186534/1115/3a5d621a/53be3639Nd10f3877.gif);
  display: inline-block;
  zoom: 1;
  height: 11px;
  margin-right: 5px;
  width: 9px;
  overflow: hidden;
  vertical-align: middle;
}
.JColorSearchList-905542  .filter .g-pager {
  float: right;
}
.JColorSearchList-905542 .filter .g-pager .fp-text {
  line-height: 24px;
  margin-right: 10px;
  font-family: verdana;
}
.JColorSearchList-905542 .filter .g-pager .fp-text b {
  color: #e4393c;
}
.JColorSearchList-905542 .filter .g-pager .fp-next,.JColorSearchList-905542 .filter .g-pager .fp-prev, .JColorSearchList-905542 .filter .g-pager .fp-text {
  float: left;
}
.JColorSearchList-905542 .filter .g-pager .fp-next.disabled, .JColorSearchList-905542 .filter .g-pager .fp-prev.disabled {
  padding: 0;
  background-color: #FFF;
  color: #c9c9c9;
  cursor: default;
  border: 1px solid #e1e1e1;
}
.JColorSearchList-905542 .filter .g-pager .fp-prev {
  margin-right: 5px;
}
.JColorSearchList-905542 .filter .g-pager .fp-next, .JColorSearchList-905542 .filter .g-pager .fp-prev {
  width: 38px;
  height: 22px;
  border: 1px solid #999;
  border-radius: 2px;
  background: #FFF;
  line-height: 23px;
  font-family: "\5b8b\4f53";
  text-align: center;
  font-size: 16px;
  color: #333;
}
.JColorSearchList-905542 .filter .f-result-sum {
  float: right;
  height: 24px;
  line-height: 24px;
  margin-right: 10px;
  color: #999;
}
.JColorSearchList-905542 .clr {
  visibility: hidden;
  display: block;
  overflow: hidden;
  clear: both;
  height: 0;
  line-height: 0;
  font-size: 0;
}
.JColorSearchList-905542 .filter .g-search {
  float: right;
  margin-right: 20px;
}
.JColorSearchList-905542 .filter .g-search .btn {
  float: left;
  height: 22px;
  line-height: 22px;
  border-top-right-radius: 11px;
  border-bottom-right-radius: 11px;
  border: solid 1px #e1e1e1;
  border-left: 0;
  width: 26px;
  padding: 0 10px;
  background: #f8f8f8 url(//img11.360buyimg.com/cms/jfs/t3916/243/24176274/1240/f8099125/5837d810N804cc68a.png) no-repeat center;
}
.JColorSearchList-905542 .filter .g-search .input-txt {
  float: left;
  color: #c9c9c9;
  height: 22px;
  line-height: 22px;
  border: 1px solid #e1e1e1;
  padding: 0 10px;
  width: 115px;
  border-top-left-radius: 11px;
  border-bottom-left-radius: 11px;
}
.JColorSearchList-905542 .goods-list {
  height: auto;
  position: relative;
  z-index: 1;
}
.JColorSearchList-905542 .goods-list .gl-warp {
  width: auto;
  height: auto;
  overflow: hidden;
  margin-right: -10px;
}
.JColorSearchList-905542 .goods-list .gl-item {
  width: 190px;
  height: 295px;
  overflow: hidden;
  float: left;
  position: relative;
  z-index: 1;
  margin: 0 10px 20px 0;
}
.JColorSearchList-905542 .goods-list .gl-item .gl-i-wrap {
  position: absolute;
  z-index: 1;
  left: 0;
  top: 0;
  background: #fff;
}
.JColorSearchList-905542 .goods-list .gl-item .jPic {
  height: 188px;
  width: 188px;
  border: solid 1px #e1e1e1;
  padding: 0;
  margin-bottom: 5px;
  position: relative;
}
.JColorSearchList-905542 .goods-list .gl-item .jPic a {
  display: block;
  position: relative;
  overflow: hidden;
}

.JColorSearchList-905542 .jScroll{height:29px; margin-bottom:10px; overflow:hidden;}
.JColorSearchList-905542 .jScrollPrev.jCurrent{background-position:-34px -126px; cursor:not-allowed;}
.JColorSearchList-905542 .jScrollPrev{background-position:0 -126px; margin-right:2px;}
.JColorSearchList-905542 .jScrollNext{background-position: -17px -126px;}
.JColorSearchList-905542 .jScrollNext.jCurrent{background-position:-51px -126px; cursor:not-allowed;}
.JColorSearchList-905542 .jScrollBtn{display:none; float:left; height:29px; text-indent:-9999px; width:16px;}
.JColorSearchList-905542 .jScrollBtn{background-image:url("//misc.360buyimg.com/201007/skin/df/i/20130606B.png"); background-repeat:no-repeat;}
.JColorSearchList-905542 .jScrollWrap{float:left; height:29px; overflow:hidden; position:relative; width:156px;}
.JColorSearchList-905542 .jScrollWrap ul{position:absolute; top:0;}
.JColorSearchList-905542 .jScrollWrap li{width:31px; height:31px; float:left; margin:0; padding:0; border:0;}
.JColorSearchList-905542 .jScrollWrap li a{float:left; border:solid 1px #ddd; padding:1px;}
.JColorSearchList-905542 .jScrollWrap li a img{height:25px; height:25px;}
.JColorSearchList-905542 .jScrollWrap li.jCurrent a{border:1px solid #E4393C;}
.JColorSearchList-905542 .jBtnArea {
  position: absolute;
  right: 0;
  top: 35px;
}
.JColorSearchList-905542 .jBtnArea a {
  float: left;
  width: 100px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  background: #ed1c24;
  cursor: pointer;
}
.JColorSearchList-905542 .jGoodsInfo{overflow:hidden;position: relative;zoom: 1;}
.JColorSearchList-905542 .jDesc{height:16px; line-height:16px; overflow:hidden; margin-bottom:5px;}
.JColorSearchList-905542 .jDesc a{font-size:12px; text-decoration:none;color: #666;white-space:nowrap;}
.JColorSearchList-905542 .jSlogan{color:#008700;}
.JColorSearchList-905542 .jPrice{overflow:hidden; margin-bottom:5px; height:15px;line-height:15px;}
.JColorSearchList-905542 .jdPrice{font-size:14px; font-weight:bold; color:#E4393C;}
.JColorSearchList-905542 .d-price-free .jRmb{display: none}
.JColorSearchList-905542 .jdPrice .jdNum{}
.JColorSearchList-905542 .jdPrice .jdStages {
  background: url(//img11.360buyimg.com/cms/jfs/t10759/204/2085617648/1012/751d32c6/59ef0adeNb99d5c49.png) no-repeat right center;
  display: inline-block;
  width: 54px;
  height: 16px;
  padding-left: 5px;
  color: #fff;
  text-align: center;
  vertical-align: top;
}
.JColorSearchList-905542 .jdPrice .jdNumNo{font-size:12px;}
.JColorSearchList-905542 .jdPrice .jdPgPrice{font-size:12px; color: #666; margin-left: 10px; font-weight: 100; font-family: verdana;}

.JColorSearchList-905542 .jExtra{height:16px; line-height:16px; overflow:hidden; padding:2px 0;}
.JColorSearchList-905542 .jExtra a{color:#999; float:left; margin-top:1px; display: none;}
.JColorSearchList-905542 .jExtra a em{color: #005AA0;}
.JColorSearchList-905542 .jExtra span{float:left; height:15px; overflow:hidden;}
.JColorSearchList-905542 .star{margin-right:5px;}
.JColorSearchList-905542 .star .star-white{background:url("//misc.360buyimg.com/201007/skin/df/i/20130606B.png") no-repeat scroll 0 -70px transparent; width:76px;}
.JColorSearchList-905542 .star .star-yellow{background:url("//misc.360buyimg.com/201007/skin/df/i/20130606B.png") no-repeat scroll 0 -86px #FFFFFF; position:relative; z-index:1;}
.JColorSearchList-905542 .star .h1{width:15px;}
.JColorSearchList-905542 .star .h2{width:30px;}
.JColorSearchList-905542 .star .h3{width:45px;}
.JColorSearchList-905542 .star .h4{width:60px;}
.JColorSearchList-905542 .star .h5{width:76px;}
.JColorSearchList-905542 .jPage {
  text-align: right;
}
.JColorSearchList-905542 .jPage a, .JColorSearchList-905542 .jPage span {
  display: inline-block;
  vertical-align: middle;
  padding: 0 10px;
  min-width: 18px;
  height: 34px;
  border: 1px solid #999;
  border-radius: 2px;
  background-color: #fff;
  color: #333;
  text-align: center;
  line-height: 34px;
  font-size: 12px;
}
.JColorSearchList-905542 .jPage a em, .JColorSearchList-905542 .jPage span em {
  font-size: 16px;
  font-family: '\5b8b\4f53';
}
.JColorSearchList-905542 .jPage .jPageCurrent {
  background-color: #333;
  color: #fff;
}
.JColorSearchList-905542 .jPage .jPageDisable {
  border-color: #e1e1e1;
  color: #c9c9c9;
}

</style>
<style scoped>
.colorGoodsSort-922474 {}
.colorGoodsSort-922474 .mc{padding: 15px 15px 0;;font-family: \5FAE\8F6F\96C5\9ED1,arial,\5b8b\4f53;background-color: #fcfcfc;}
.colorGoodsSort-922474 .jOneLevel{overflow:hidden;text-align: center}
.colorGoodsSort-922474 .jOneLevel .jClassi{font-size: 12px;color: #999;font-family: arial,\5FAE\8F6F\96C5\9ED1,\5b8b\4f53;}
.colorGoodsSort-922474 .jOneLevel .jHead {
  position: relative;
  font-size: 22px;
  height: 30px;
  line-height: 30px;
  color: #000;
  padding: 0 20px 15px;
  border-bottom: 1px solid #e1e1e1;
}
.colorGoodsSort-922474 .jOneLevel .jHead .jDottedleft {
  position: absolute;
  display: block;
  left: 20px;
  top: 13px;
  height: 4px;
  width: 4px;
  background: url(//img14.360buyimg.com/cms/jfs/t3448/126/18152604/1049/6f71a7fc/57fd94c0N39f3eb9c.png) no-repeat;
}
.colorGoodsSort-922474 .jOneLevel .jHead  .jDottedRight {
  position: absolute;
  display: block;
  right: 20px;
  top: 13px;
  height: 4px;
  width: 4px;
  background: url(//img14.360buyimg.com/cms/jfs/t3448/126/18152604/1049/6f71a7fc/57fd94c0N39f3eb9c.png) no-repeat;
}
.colorGoodsSort-922474 .jTwoLevel {
  font-size: 14px;
  font-weight: bold;
  height: 45px;
  line-height: 45px;
  overflow: hidden;
  color: #e1e1e1;
  clear: both;
  text-align: center;
  border-bottom: dashed 1px #e1e1e1;
  position: relative;
}
.colorGoodsSort-922474 .jTwoLevel.jNoBorderBottm{border-bottom:0;}
.colorGoodsSort-922474 .jIconArrow {
  display: block;
  width: 20px;
  height: 20px;
  cursor: pointer;
  position: absolute;
  right: 0;
  background: url(//img20.360buyimg.com/cms/jfs/t3442/274/61048783/1064/3b52ecb8/57fd94c0N66bbe258.png) no-repeat center;
  top: 13px;
}
.colorGoodsSort-922474 .current .jIconArrow {
  transform: rotate(90deg);
}
.colorGoodsSort-922474 .jTwoLevel a{
  display: block;
  color: #333;
  overflow: hidden;
}
.colorGoodsSort-922474 .jThreeLevel{overflow:hidden; _height:100%;}

.colorGoodsSort-922474 .jThreeLevel li {
  height: 34px;
  line-height: 34px;
  overflow: hidden;
}

.colorGoodsSort-922474 .jThreeLevel a {
  display: block;
  height: 24px;
  margin-top: 5px;
  line-height: 24px;
  font-size: 14px;
  text-align: center;
  border-radius: 12px;
}

.colorGoodsSort-922474 .jThreeLevel a:hover {
  background-color: #efefef;
  color: #666;
}

</style>
<style scoped>
.page-content{
  width: 100%;
}
.left-right-div{
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  margin-top: 30px;
}
.left-div{
  margin-right: 20px;
}
</style>
<style scoped lang="css" src="./fmh/layout.css" />
<style scoped lang="css" src="./fmh/normalize.css" />
<style scoped lang="css" src="./fmh/layout.css" />
<style scoped lang="css" src="./fmh/elevator.c708a4ea.css" />
<style scoped lang="css" src="./fmh/normalize.css" />
<style scoped lang="css" src="./fmh/shortcutNew.a19ad2f9.css" />
<style scoped lang="css" src="./fmh/saved_resource" />
<style scoped lang="css" src="./fmh/saved_resource(1)" />
<style scoped lang="css" src="./fmh/saved_resource(2)" />
<style scoped lang="css" src="./fmh/shortcutNew.a19ad2f9.css" />
